import i18n from "@/shared/i18n";

export enum ParticipantTypeEnum {
  Absent = 1,
  Attendee = 2,
  JoinViaCall = 3,
  Guest = 4,
}

export enum EventTypeEnum {
  OneOnOne = 1,
  Group = 2,
  Event = 3,
}

export const EventTypes = () => [
  {
    label: i18n.t("recap.call"),
    value: EventTypeEnum.OneOnOne,
  },
  {
    label: i18n.t("recap.call"),
    value: EventTypeEnum.Group,
  },
  {
    label: i18n.t("recap.calendarEvent"),
    value: EventTypeEnum.Event,
  },
];

export const ParticipantTypes = () => [
  {
    label: i18n.t("recap.absent"),
    value: ParticipantTypeEnum.Absent,
  },
  {
    label: i18n.t("recap.attendee"),
    value: ParticipantTypeEnum.Attendee,
  },
  {
    label: i18n.t("recap.joinedViaCall"),
    value: ParticipantTypeEnum.JoinViaCall,
  },
  {
    label: i18n.t("recap.guest"),
    value: ParticipantTypeEnum.Guest,
  },
];

export enum RecapTabEnum {
  Attendance = 1,
  VideoAndTranscription = 2,
  ActionItems = 3,
  Decisions = 4,
  Minutes = 5,
}
